module.exports = __webpack_public_path__ + "img/gallery-4.e26f6ce0.jpg";